import {createTailwindMerge, fromTheme, getDefaultConfig, mergeConfigs} from 'tailwind-merge'
import themes from '../preset/themes'

const getTwMergeConfig = () => {
	const config = getDefaultConfig()

	return mergeConfigs(config, {
		classGroups: {
			'font-size': [{text: [(value) => Number(value)]}],
			color: [{text: [...Array.from(new Set(Object.keys(themes).map(key => Object.keys(themes[key])).flat())), fromTheme('color')]}],
		},
	})
}

export const twMergeConfig = getTwMergeConfig()
export const twMerge = createTailwindMerge(getTwMergeConfig)
